import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Ho organizzato tutta la mia pianificazione didattica in un weekend. Ora so esattamente cosa insegnare ogni lezione per portare le mie allieve al livello successivo. Non improvviso più.',
  author: 'Maria Grazia C.',
  role: 'Insegnante di Danza Classica',
  location: 'Bologna'
}, {
  quote: 'Le progressioni tecniche hanno cambiato tutto. Le mie allieve hanno finalmente una struttura chiara e i miglioramenti si vedono settimana dopo settimana. E senza infortuni alle articolazioni.',
  author: 'Francesca R.',
  role: 'Titolare di Scuola di Danza',
  location: 'Milano'
}, {
  quote: "Adatto l'intensità della lezione in base al livello del gruppo in 5 minuti. Prima mi ci volevano ore a cercare esercizi su YouTube per mettere insieme qualcosa di coerente.",
  author: 'Valentina T.',
  role: 'Istruttrice di Ballet Fitness',
  location: 'Torino'
}];
export function Testimonials() {
  return <section className="py-12 md:py-20 bg-white" data-id="element-234">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-236">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-ballet-50 p-6 md:p-8 rounded-2xl shadow-sm border border-ballet-100 relative transition-all duration-300 hover:shadow-md hover:-translate-y-1" data-id="element-237">
              <div className="flex text-ballet-400 mb-3 md:mb-4" data-id="element-238">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-239" />)}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-240">
                "{testimonial.quote}"
              </p>
              <div data-id="element-241">
                <p className="font-bold text-charcoal" data-id="element-242">{testimonial.author}</p>
                <p className="text-sm text-gray-500" data-id="element-243">
                  {testimonial.role} — {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}